interface QuotePriceValues {
  price?: unknown;
  last?: unknown;
  close?: unknown;
}

export const quoteToPrice = (quote: QuotePriceValues | null | undefined): number | null => {
  if (!quote) return null;
  const value = quote.price ?? quote.last ?? quote.close;
  return value !== undefined && value !== null && !Number.isNaN(Number(value)) ? Number(value) : null;
};
